export const ru = {
    administration: 'Администрирование',
    blog: 'Блог',
    'budget-forecast': 'Прогноз бюджета',
    cases: 'Кейсы',
    club: 'Клуб',
    help: 'Помощь',
    'my-campaigns': 'Мои кампании',
    'my-clients': 'Мои клиенты',
    'online-courses': 'Онлайн курсы',
    search: 'Поиск',
    site: 'Сайт',
    study: 'Обучение',
    'word-stat': 'Подбор слов'
};
